// extracted by mini-css-extract-plugin
module.exports =  {"expandableTitle":"expandableTitle_HyHIJSxI","assumptionCount":"assumptionCount_VFZYZAbr","accountTitle":"accountTitle_JvW3ywxy"};